import Vue from 'vue'
import { Dictionary } from 'vue-router/types/router'
import router from './core'
import ROUTE from './routeEnum'

export default Vue.extend({
    methods: {
        navigateOutsideTo(url: string) {
            window.location.href = url
        },
        navigateTo(route: ROUTE, params : Dictionary<string> | undefined = undefined) {
            if (this.$route.name != route) router.push({ name: route, params : params })
        },
        navigateToHome() {
            this.navigateTo(ROUTE.HOME)
        },
        navigateToLogin() {
            this.navigateTo(ROUTE.AUTH)
        },
        navigateToProfile() {
            this.navigateTo(ROUTE.PROFILE)
        },
        navigateToPDFViewer(pdfUrl: string){
            router.push({ name: ROUTE.PDF, params : { pdfUrl : pdfUrl} })
        },
        query(param: string) {
            return this.$route.query[param]?.toString()
        },
        baseUrl() {
            return window.location.origin
        }
    }
})
